import { FormErrorMessages } from '../components/form/form-error/form-error-messages';

export class FormValidationUtils {
  public static readonly DEFAULT_FORM_ERROR_MESSAGES: FormErrorMessages = {
    required: $localize`Required`,
    maxFileSize: $localize`The file exceeds the size limit`,
  };
}
